// This file will be resolved by webpack aliases to the correct TradingViewContainer
// based on the REACT_APP_IS_INDIAN_EXCHANGE environment variable

import { IS_INDIAN_EXCHANGE } from 'constants/constants';

// The actual import will be resolved at build time by webpack aliases:
// - TradingViewContainer.tsx when REACT_APP_IS_INDIAN_EXCHANGE=true
// - TradingViewContainer.global.tsx when REACT_APP_IS_INDIAN_EXCHANGE=false
const TradingViewContainer = IS_INDIAN_EXCHANGE
  ? require('./TradingViewContainer.indian').default
  : require('./TradingviewContainer.global').default;

export default TradingViewContainer;
